export const HRInterviewStatus = {
  Todo: 'TODO',
  Done: 'DONE',
  Cancelled: 'CANCELLED',
} as const;

export const HRInterviewComputedStatus = {
  ...HRInterviewStatus,
  ToProcess: 'TO_PROCESS',
} as const;

export const HRRecallComputedStatus = {
  Active: 'ACTIVE',
  Done: 'DONE',
  Expired: 'EXPIRED',
} as const;
